/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Iframe from 'DesignSystem/Iframe/react'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/LauncherModalFullscreen/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let patientImageLauncherNameValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'launcher.name',
})
let patientImageLauncherUrlValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'launcher.url',
})
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="fullscreen"
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 data="patient_image.launcher.name"
 text={patientImageLauncherNameValueData}
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<Iframe
{...childProps}
  viewPath={`${viewPath}/Iframe`}
 data="patient_image.launcher.url"
 src={patientImageLauncherUrlValueData}
/>
)}
</TysiaModalContent>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}